/*
 * --------------------------------------------------------------------
 * File: \src\app\dashboardSlice.js
 * Created: Thursday, 3rd October 2024 2:26:33 pm
 * Modified: Thursday, 3rd September 2024 2:26:33 pm
 * Author: Muhammad Amirul Faisal
 * 
 * Copyright (c) 2024 - System Consultancy Services Sdn. Bhd.
 * --------------------------------------------------------------------
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    monthSelected: new Date().getMonth(),
    dateSelected: {month: new Date().getMonth(), year: new Date().getFullYear()}
}

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        setMonthSelected: (state, action) => {
            state.monthSelected = action.payload;
        },
        setDateSelected: (state, action) => {
            state.dateSelected = action.payload;
        },
    },
});

export const {
    setMonthSelected,
    setDateSelected
} = dashboardSlice.actions;

export const getJumlahKutipanBulanan = (state) => state.dashboard.jumlahKutipanBulanan;
export const getJumlahKutipanTahunan = (state) => state.dashboard.jumlahKutipanTahunan;
export const getBilanganTransaksiBulanan = (state) => state.dashboard.bilanganTransaksiBulanan;
export const getMonthSelected = (state) => state.dashboard.monthSelected;
export const getDateSelected = (state) => state.dashboard.dateSelected;

export default dashboardSlice.reducer;